module.exports = __webpack_public_path__ + "static/gallery2-1573fe699b472f9aae50773fd46c2c6d.jpg";